module.exports = __webpack_public_path__ + "static/media/pakiet_1200X900_05ksiazka.cf6a20aa.jpg";